// @ts-expect-error moduleResolution:nodenext issue 54523
import { LitElement } from 'lit';

// https://github.com/lit/lit-element/issues/42
export default class LitElementLight extends LitElement {
	slotMap: object;

	connectedCallback() {
		this.slotMap = Array
			.from(this.querySelectorAll('[slot]'))
			.reduce((map, obj) => ({
				...map,
				[obj.getAttribute('slot')]: obj
			}), {});

		super.connectedCallback();
	}

	protected getSlot(slotName: string): ChildNode {
		return this.slotMap && this.slotMap[slotName];
	}

	createRenderRoot() {
		return this;
	}
}
